import { Routes } from '@angular/router';
import { AuthGuard } from 'src/app/shared/guards/auth.guard';
import { DeleteAccountPage } from '../_delete-account/delete-account';
import { NotFoundPage } from '../_not-found/not-found';
import { PlatformCorePage } from '../_platform-core/platform-core.page';
import { platformCoreRoutes } from '../_platform-core/platform-core.routes';
import { authRoutes } from '../auth/auth.routes';
import { documentRoutes } from '../document/document.routes';
import { PrivacyPolicyPage } from './pages/privacy-policy/privacy-policy';

export const coreRoutes: Routes = [
    { path: '', redirectTo: 'platform', pathMatch: 'full' },
    { path: 'auth', children: authRoutes },
    {
        path: 'platform',
        component: PlatformCorePage,
        canActivate: [AuthGuard],
        children: platformCoreRoutes,
    },
    {
        path: 'document',
        children: documentRoutes,
    },
    {
        // Consentimento OAuth do MCP (apps de IA). Pública: a página mesma manda para o
        // login e volta para cá (ver McpAuthorizePage).
        path: 'oauth/authorize',
        loadComponent: () =>
            import('../mcp/pages/authorize/mcp-authorize.page').then(x => x.McpAuthorizePage),
    },
    { path: 'delete-account', component: DeleteAccountPage },
    { path: 'not-found', component: NotFoundPage },
    { path: 'privacy-policy', component: PrivacyPolicyPage },
    { path: '**', redirectTo: 'not-found', pathMatch: 'full' },
];
